import createIcon from '../../createIcon';

/**
 * @component @name CodeOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNDc1MyAxMS4yOUwxNC44OTUzIDYuNjk5OThMMTYuMzA1MyA1LjI4OTk4TDIyLjMwNTMgMTEuMjlMMTguNzE1MyAxNC44OEwxNy4zMDUzIDEzLjQ2TDE5LjQ3NTMgMTEuMjlaTTEuNjk1MzEgMy41MDk5OEw1Ljg4NTMxIDcuNjk5OThMMi4zMDUzMSAxMS4yOUw4LjMwNTMxIDE3LjI5TDkuNzE1MzEgMTUuODhMNS4xMzUzMSAxMS4yOUw3LjMwNTMxIDkuMTE5OThMMjAuMDg1MyAyMS45TDIxLjQ5NTMgMjAuNDlMMy4xMTUzMSAyLjA5OTk4TDEuNjk1MzEgMy41MDk5OFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CodeOff = createIcon('CodeOff', [
  [
    'path',
    {
      d: 'M19.4753 11.29L14.8953 6.69998L16.3053 5.28998L22.3053 11.29L18.7153 14.88L17.3053 13.46L19.4753 11.29ZM1.69531 3.50998L5.88531 7.69998L2.30531 11.29L8.30531 17.29L9.71531 15.88L5.13531 11.29L7.30531 9.11998L20.0853 21.9L21.4953 20.49L3.11531 2.09998L1.69531 3.50998Z',
      key: 'h9mbby',
    },
  ],
]);

export default CodeOff;
